import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { RouterOutlet } from '@angular/router';
import { ViewHeaderPortalComponent } from '../../ui/view-header-portal/view-header-portal.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { NgtThemeService } from '@corporate/ng-tebis-base-components';

@Component({
  selector: 'app-main-layout',
  imports: [
    MainMenuComponent,
    RouterOutlet,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutComponent implements OnInit {

  themeService = inject(NgtThemeService);
  viewHeaderPortal: ComponentPortal<ViewHeaderPortalComponent> | undefined;

  darkMode = this.themeService.isDarkMode;

  ngOnInit() {
    this.viewHeaderPortal = new ComponentPortal<ViewHeaderPortalComponent>(ViewHeaderPortalComponent);
  }

}
